import React, { Component } from "react"
import PropTypes from "prop-types"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import "react-toastify/dist/ReactToastify.css";
import axios from "axios"
import {
  getClientDetail
} from "../../store/actions"

import {
  Col,
  Container,
  Row,
  Table,
   Card,
  CardBody,
CardHeader
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Moment from 'react-moment';
import { API_URL } from "helpers/app_url";
import ClientSellerBreadcrumbs from "components/Common/ClientSellerBreadcrumbClient";
import NoAccess from "components/NoAccess";
import ClientSidebar from "components/VerticalLayout/ClientSidebar";

class OfferCompare extends Component {
  constructor(props) {
    super(props);
    this.state = {
     
    }
   
    
  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail} = this.props;
    onGetClientDetail(params.clientId);
    this.fetchOffer();

  }
 fetchOffer() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      listingId: this.props.match.params.id,
      agentId: parseInt(localStorage.getItem('userId')),
    }
    axios
      .get(`${API_URL}ClientOffer/GetSellerClientOffersByListingIdForCompare`, { headers, params })
      .then((response) => {
        this.setState({ offersData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  render() {
    const { clietDetail } = this.props;
    const { offersData } = this.state;
    const hasSellerType = clietDetail.clientTypes && clietDetail.clientTypes.some((type) => type.clientTypeCode === 2);
   
  const offers = offersData?.map(item => ({
  agent: item.agentName || item.partyName || "N/A",
  offerDate: item.offerDate
    ? new Date(item.offerDate).toLocaleDateString("en-US", { day: 'numeric', month: 'short', year: 'numeric' })
    : "N/A",
  price: item.askingPrice ? `$${item.askingPrice.toLocaleString()}` : "N/A",
  deposit: item.deposit ? `$${item.deposit.toLocaleString()}` : "N/A",
  closingDate: item.closingDate
    ? new Date(item.closingDate).toLocaleDateString("en-US", { day: 'numeric', month: 'short', year: 'numeric' })
    : "N/A",
  expiry: item.expiryDate
    ? new Date(item.expiryDate).toLocaleDateString("en-US", { day: 'numeric', month: 'short', year: 'numeric' })
    : "N/A",
  conditions: item.clientDealConditionStates
    ?.filter(c => c.status === true)
    .map(c => c.clientDealConditionTitle || `Condition ${c.clientDealConditionId}`)
})) || []; 
const allConditionTitles = Array.from(
  new Set(offers.flatMap(o => o.conditions || []))
);
//

    return (
      <React.Fragment>
          
          
       
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Projects | Realty Space</title>
          </MetaTags>
          <Container fluid className="">
          {hasSellerType ? (
                       <Row>
                         <Col sm='2' className="pe-0">
                           <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} />
                         </Col>
                         <Col sm='10' className="">
                           <Row className="project-header">
                             <Col sm="7">
                               <ClientSellerBreadcrumbs
                                 title={this.props.t("Clients")}
                                 breadcrumbItem={this.props.t(" Offer Compare")}
                               />
                             </Col>
                             <Col sm="4" className="">
                               <h2 className="">{this.props.t(clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                             </Col>
                           </Row>
                           <Card className="compare-card">
                                     <Table bordered responsive>
        <thead>
          <tr>
            <th>Overview</th>
            {offers.map((o, i) => (
              <th key={i} className="">{o.agent}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Offer date</td>
            {offers.map((o, i) => <td key={i}>{o.offerDate}</td>)}
          </tr>
          <tr>
            <td>Offer Price</td>
            {offers.map((o, i) => <td key={i}>{o.price}</td>)}
          </tr>
          <tr>
            <td>Deposit amount</td>
            {offers.map((o, i) => <td key={i}>{o.deposit}</td>)}
          </tr>
          <tr>
            <td>Closing Date</td>
            {offers.map((o, i) => <td key={i}>{o.closingDate}</td>)}
          </tr>
          <tr>
            <td>Offer expiry date/time</td>
            {offers.map((o, i) => <td key={i}>{o.expiry}</td>)}
          </tr>

          {/* Divider row for Conditions */}
          <tr className="table-secondary">
            <td colSpan={offers.length + 1}><strong>Conditions</strong></td>
          </tr>
          {allConditionTitles.map((title, idx) => (
          <tr key={idx}>
            <td>{title}</td>
            {offers.map((o, i) => (
              <td key={i}>{o.conditions.includes(title) ? "✔️" : ""}</td>
            ))}
          </tr>
        ))}
        </tbody>
      </Table>
                            </Card>
                     
                         </Col>
                       </Row>
                     ) : (
                       <NoAccess />
         
                     )}
           
        
    

    
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

OfferCompare.propTypes = {
    t: PropTypes.any,
    match: PropTypes.object,
    history: PropTypes.object,
    onGetClientDetail: PropTypes.func,
    clietDetail: PropTypes.object

}

const mapStateToProps = ({Clients}) => ({
     clietDetail: Clients.clietDetail,
})

const mapDispatchToProps = dispatch => ({
    onGetClientDetail: (clientId) => dispatch(getClientDetail(clientId)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(OfferCompare)))